<template>
  <div>
    <div v-if="user != null">
      <img :src="logoApp" class="center" />
    </div>
  </div>
</template>

<style scoped>
.center {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -150px;
  margin-top: -50px;
}
</style>

<script>
import Vue from "vue";

export default {
  name: "Home",
  data: () => ({
    user: null
  }),
  async beforeCreate() {
    //redirection
    if (!Vue.$keycloak.authenticated) {
      Vue.$keycloak.login();
    }
  },
  computed: {
    userName: function() {
      return this.user != null ? this.user.username : "";
    },
    logoApp() {
      try {
        return require("@/assets/tracking.png");
      } catch (error) {
        return "";
      }
    }
  }
};
</script>
